import React, { useRef } from 'react';
import styled from 'styled-components';

import { useModal } from '../../../Providers/ModalContext';
import Modal from '../../../Global/Modal';
import RichText from '../../../Global/RichText';

import CloseIcon from '../../../../Images/icons/close-icon.png';
import PhotoBg from '../../../../Images/background/bg_photographers.png';
import LogoStudio from '../../../../Images/logos/logo-studio.png';

import PhotoErik from '../../../../Images/modals/photographers/all/photo_erick.png';
import PhotoAlejandro from '../../../../Images/modals/photographers/all/photo_alejandro.png';
import PhotoCarlos from '../../../../Images/modals/photographers/all/photo_carlos.png';
import PhotoGregory from '../../../../Images/modals/photographers/all/photo_gregory.png';
import PhotoJose from '../../../../Images/modals/photographers/all/photo_jose.png';
import PhotoMario from '../../../../Images/modals/photographers/all/photo_mario.png';
import PhotoYvone from '../../../../Images/modals/photographers/all/photo_yvone.png';

import PhotoErikMob from '../../../../Images/modals/photographers/erick/bg_erick.png';
import PhotoAlejandroMob from '../../../../Images/modals/photographers/alejandro/bg_alejandro.png';
import PhotoCarlosMob from '../../../../Images/modals/photographers/carlos/bg_carlos.png';
import PhotoGregoryMob from '../../../../Images/modals/photographers/gregory/bg_gregory.png';
import PhotoJoseMob from '../../../../Images/modals/photographers/jose/bg_jose.png';
import PhotoMarioMob from '../../../../Images/modals/photographers/mario/bg_mario.png';
import PhotoYvoneMob from '../../../../Images/modals/photographers/yvone/bg_yvone.png';

import {
  Photo_Title,
  Photo_Erick,
  Photo_Gregory,
  Photo_Jose,
  Photo_Yvone,
  Photo_Mario,
  Photo_Alejandro,
  Photo_Carlos,
} from '../../../../utils/EN/Modals/photographers';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const ModalContent = styled.div`
  width: 100%;
  position: relative;
  padding: 25px 0px;
  display: flex;
  align-items: flex-start;

  flex-direction: column;
  gap: 4rem;
  overflow: hidden;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 25px 0 0 0 !important;
    gap: 0rem;
  }
`;

const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 3.375rem;
  padding-right: 5%;
  padding-left: 110px;

  @media (max-width: ${breakpoints.mobile}) {
    padding-left: 30px;
  }

  p,
  h2,
  h3 {
    text-transform: uppercase;
  }
`;

const LogoContent = styled.div`
  display: block;
  max-width: 276px;
  width: 100%;
  padding: 15px;
  position: relative;

  img {
    display: block;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease-out;

    &:hover {
      filter: drop-shadow(0px 0px 20px rgba(250, 115, 19, 1));
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 93px;
    background: #fff;

    top: 0;
    bottom: 0;

    margin: auto;
    right: -10%;
  }
`;

const DirectorsContainer = styled.div`
  width: 100%;
  height: 540px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 7rem;
  position: relative;
  overflow: hidden;

  @media (max-width: ${breakpoints.tablet}) {
    height: 100%;
    flex-direction: column;
    margin-top: 1rem;
  }
`;

const DirectorCard = styled.div`
  position: absolute;
  width: ${({ $widthContainer = '270px' }) => $widthContainer};
  height: 460px;

  cursor: pointer;
  object-fit: cover;
  transition: 0.4s;

  @media (max-width: ${breakpoints.desktop}) {
    width: 240px;
    height: 370px;
  }

  @media (max-width: ${breakpoints.tablet}) {
    position: relative;
    width: 100%;
    height: 470px;
    left: 0;
  }

  @media (max-width: ${breakpoints.mobile}) {
    position: relative;
    width: 100%;
    height: 227px;
    left: 0;
  }

  &:hover {
    h3 {
      text-shadow: 0px 0px 20px rgba(255, 255, 255, 1);
    }
  }

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 160px;
    background: rgba(0, 0, 0, 0);
  }

  img {
    width: auto;
    height: 100%;
    display: block;

    @media (max-width: ${breakpoints.tablet}) {
      display: none;
    }

    &.mobile {
      width: 100%;
      height: 100%;
      display: none;
      object-fit: cover;

      @media (max-width: ${breakpoints.tablet}) {
        display: block;
      }
    }
  }

  h3 {
    text-align: center;
    cursor: pointer;

    position: absolute;
    bottom: 5%;
    right: 0;
    left: 0;
    margin: 0 auto;
    z-index: 5;

    transition: all 0.3s ease;

    @media (max-width: ${breakpoints.desktop}) {
      font-size: 1.5rem;
    }

    @media (max-width: ${breakpoints.tablet}) {
      bottom: 0;
      top: 50%;
      transform: translate(20%, -30%);
    }
  }

  ${({ index }) => {
    const positions = {
      1: { left: '0%', z: 1, scale: 1 },
      2: { left: '12%', z: 2, scale: 1 },
      3: { left: '27%', z: 3, scale: 1 },
      4: { left: '43%', z: 5, scale: 1 },
      5: { left: '55%', z: 3, scale: 1 },
      6: { left: '70%', z: 2, scale: 1 },
      7: { left: '85%', z: 1, scale: 1 },
    };

    return `
      left: ${positions[index].left};
      z-index: ${positions[index].z};
      transform: scale(${positions[index].scale});
    `;
  }}
`;

const ModalPhotographers = () => {
  const { closeModal } = useModal();

  const { openModal } = useModal();

  const handleClick = (e) => {
    const target = e.currentTarget.dataset.target;
    openModal(target);
  };

  return (
    <>
      <Modal
        id="photographers"
        bgImg={PhotoBg}
        bgColor={'rgba(0, 0, 0, 1)'}
        bgPosition={'top center'}
        padding={'40px 0px'}
        mobPadding={'20px 0px'}
      >
        <CloseContainer>
          <CloseButton
            onClick={closeModal}
            aria-label="Close modal"
            src={CloseIcon}
          />
        </CloseContainer>
        <ModalContent>
          <TitleContent>
            <LogoContent>
              <img
                src={LogoStudio}
                onClick={closeModal}
                aria-label="Close modal"
                alt="Kuter Studio"
              />
            </LogoContent>
            <RichText dataText={Photo_Title} />
          </TitleContent>
          <DirectorsContainer>
            <DirectorCard
              index={1}
              onClick={handleClick}
              data-target="photo-erick"
            >
              <img src={PhotoErik} alt="Erick Guevara" />
              <img src={PhotoErikMob} className="mobile" alt="Erick Guevara" />
              <RichText
                dataText={Photo_Erick}
                onClick={handleClick}
                data-target="photo-erick"
              />
            </DirectorCard>
            <DirectorCard
              index={2}
              onClick={handleClick}
              data-target="photo-gregory"
            >
              <img src={PhotoGregory} alt="Gregory Allen" />
              <img
                src={PhotoGregoryMob}
                className="mobile"
                alt="Gregory Allen"
              />
              <RichText
                dataText={Photo_Gregory}
                onClick={handleClick}
                data-target="photo-gregory"
              />
            </DirectorCard>
            <DirectorCard
              index={3}
              onClick={handleClick}
              data-target="photo-jose"
            >
              <img src={PhotoJose} alt="Jose R Gagigas" />
              <img src={PhotoJoseMob} className="mobile" alt="Jose R Gagigas" />
              <RichText
                dataText={Photo_Jose}
                onClick={handleClick}
                data-target="photo-jose"
              />
            </DirectorCard>
            <DirectorCard
              index={4}
              onClick={handleClick}
              data-target="photo-yvone"
            >
              <img src={PhotoYvone} alt="Yvone Belanger" />
              <img
                src={PhotoYvoneMob}
                className="mobile"
                alt="Yvone Belanger"
              />
              <RichText
                dataText={Photo_Yvone}
                onClick={handleClick}
                data-target="photo-yvone"
              />
            </DirectorCard>
            <DirectorCard
              index={5}
              onClick={handleClick}
              data-target="photo-mario"
            >
              <img src={PhotoMario} alt="Mario Macin" />
              <img src={PhotoMarioMob} className="mobile" alt="Mario Macin" />
              <RichText
                dataText={Photo_Mario}
                onClick={handleClick}
                data-target="photo-mario"
              />
            </DirectorCard>
            <DirectorCard
              index={6}
              onClick={handleClick}
              data-target="photo-alejandro"
            >
              <img src={PhotoAlejandro} alt="Alejandro Yañes" />
              <img
                src={PhotoAlejandroMob}
                className="mobile"
                alt="Alejandro Yañes"
              />
              <RichText
                dataText={Photo_Alejandro}
                onClick={handleClick}
                data-target="photo-alejandro"
              />
            </DirectorCard>
            <DirectorCard
              index={7}
              onClick={handleClick}
              data-target="photo-carlos"
            >
              <img src={PhotoCarlos} alt="Carlos Somonte" />
              <img
                src={PhotoCarlosMob}
                className="mobile"
                alt="Carlos Somonte"
              />
              <RichText
                dataText={Photo_Carlos}
                onClick={handleClick}
                data-target="photo-carlos"
              />
            </DirectorCard>
          </DirectorsContainer>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalPhotographers;
